import React from "react";

export default function Terms() {
  const card = {
    maxWidth: 980,
    margin: "0 auto",
    borderRadius: 18,
    padding: "18px 16px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(0,0,0,0.55)",
    boxShadow: "0 22px 70px rgba(0,0,0,0.60)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  };

  const h1 = { margin: 0, fontSize: 28, fontWeight: 900, letterSpacing: 0.2 };
  const h2 = { marginTop: 18, fontSize: 16, fontWeight: 900 };
  const p = { marginTop: 10, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 };

  return (
    <div style={card}>
      <h1 style={h1}>Terms & Conditions</h1>
      <div style={{ marginTop: 6, color: "rgba(255,255,255,0.70)", fontSize: 13 }}>
        Last updated: January 1, 2026
      </div>

      <p style={p}>
        By using GAStreaming, you agree to these Terms. If you do not agree, please do not use the site.
      </p>

      <div style={h2}>Accounts</div>
      <ul style={{ marginTop: 8, paddingLeft: 18, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 }}>
        <li>You are responsible for your account credentials and activity.</li>
        <li>Do not attempt to bypass payment gates or access restricted features without authorization.</li>
        <li>We may suspend or terminate accounts that violate these Terms or our Community Guidelines.</li>
      </ul>

      <div style={h2}>Acceptable use</div>
      <ul style={{ marginTop: 8, paddingLeft: 18, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 }}>
        <li>No harassment, hate speech, threats, or doxxing.</li>
        <li>No spam, scams, or abusive automation.</li>
        <li>No attempts to hack, exploit, reverse engineer, or disrupt the service.</li>
      </ul>

      <div style={h2}>User content (chat, uploads, profiles)</div>
      <p style={p}>
        You are responsible for content you submit. You must have the rights to post it. We may remove content
        that violates policies, laws, or platform safety.
      </p>

      <div style={h2}>Payments, merch, and third parties</div>
      <p style={p}>
        Donations, subscriptions, and purchases may be processed by third‑party providers. Merch orders may be
        fulfilled by a fulfillment partner. All purchases are subject to the provider’s policies in addition
        to these Terms.
      </p>

      <div style={h2}>Disclaimers</div>
      <p style={p}>
        GAStreaming is provided “as is” without warranties. We do not guarantee uninterrupted service and are
        not responsible for outages, data loss, or third‑party service failures.
      </p>

      <div style={h2}>Changes</div>
      <p style={p}>
        We may update these Terms from time to time. We’ll post the updated date at the top of this page.
      </p>
    </div>
  );
}
